import { render, staticRenderFns } from "./lead.vue?vue&type=template&id=45833174"
import script from "./lead.vue?vue&type=script&lang=js"
export * from "./lead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports